<template>
  <a-card :bordered="false">
    <a-form layout="inline">
      <a-form-item label="门店名称">
        <a-input v-model="queryParams.storeName" placeholder="请输入门店名称"></a-input>
      </a-form-item>
      <a-form-item label="门店区域">
        <a-cascader
          :options="provinceList"
          @change="onCityChange"
          :value="defaultCityValue"
          :showSearch="{ filter }"
          changeOnSelect
          placeholder="请选择区域"
        />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
        <a-button @click="onAddShop(0)">添加门店</a-button>
        <a-button @click="openSetting">投放设置</a-button>
      </a-form-item>
    </a-form>
    <custom-page-table
      style="margin-top:16px;"
      ref="table"
      :queryParams="queryParams"
      :columns="columns"
      base-key="userUrl"
      params-path="user/merchantStore/getMerchantStoreList"
    >
      <span slot="status" slot-scope="rowItem">
        {{ rowItem.record.status == 1 ? '显示' : '隐藏' }}
      </span>
      <span slot="storeManger" slot-scope="rowItem">
        <div>{{ rowItem.record.storeMangerName }}</div>
        <div>{{ rowItem.record.storeMangerPhone }}</div>
      </span>
      <span slot="action" slot-scope="rowItem">
        <a @click="onAddShop(rowItem.record.storeId)">修改</a>
        <a-divider type="vertical"/>
        <a @click="onBindAccount(rowItem.record.storeId)">店员设置</a>
        <a-divider type="vertical"/>
        <a @click="goPerformance(rowItem.record)">店员业绩</a>
        <a-divider type="vertical"/>
        <a-popconfirm title="此操作将删除此门店, 是否继续?" @confirm="deleteStore(rowItem.record.storeId)">
          <a>删除</a>
        </a-popconfirm>
      </span>
    </custom-page-table>
    <a-modal title="投放设置" :width="550" :footer="null" :visible="visible" @cancel="handleCancel">
      <a-form-model :rules="rules" ref="ruleForm" :model="ruleForm" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="投放模式" prop="pattern">
          <a-radio-group v-model="ruleForm.pattern">
            <a-radio :value="1">传统门店</a-radio>
            <a-radio :value="2">在线顾问</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="显示店铺" prop="showPosition">
          <a-checkbox-group v-model="ruleForm.showPosition">
            <a-checkbox value="1">仅一级运营商店</a-checkbox>
            <a-checkbox value="2">仅二级分销商店</a-checkbox>
          </a-checkbox-group>
        </a-form-model-item>
        <a-form-model-item label="状态" prop="status">
          <a-radio-group v-model="ruleForm.status">
            <a-radio :value="2">关闭</a-radio>
            <a-radio :value="1">开启</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="首页图片" prop="showPicture">
          <p style="color:red;">推荐尺寸1380px*258px，格式.png .jpg .gif</p>
          <div>
            <a-upload
              class="avatar-uploader"
              list-type="picture-card"
              :action="actionImageUrl"
              @change="handleChange"
              :showUploadList="false"
            >
              <img v-if="ruleForm.showPicture" :src="ruleForm.showPicture" class="avatar"/>
              <div v-else>
                <a-icon type="plus"/>
                <div class="ant-upload-text">Upload</div>
              </div>
            </a-upload>
          </div>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 12, offset: 5 }">
          <a-button type="primary" @click="submitForm('ruleForm')" :loading="submitLoading">保 存</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
export default {
  name: 'ShopList',
  data() {
    return {
      columns: [
        {
          title: '门店ID',
          dataIndex: 'storeId'
        },
        {
          title: '门店名称',
          dataIndex: 'storeName'
        },
        {
          title: '门店地址',
          dataIndex: 'storeAddress'
        },
        {
          title: '电话',
          dataIndex: 'storePhone'
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '店长账号',
          dataIndex: 'storeManger',
          scopedSlots: { customRender: 'storeManger' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '260px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      submitLoading: false,
      // 查询条件
      queryParams: {
        storeName: '',
        provinceId: undefined,
        cityId: undefined
      },
      provinceList: [],
      defaultCityValue: [],
      actionImageUrl: this.getAppConfig().baseUrl + 'base/upload',
      labelCol: { span: 5 },
      wrapperCol: { span: 17 },
      visible: false,
      ruleForm: {
        pattern: '',
        showPosition: [],
        showPicture: '',
        id: 0,
        status: 2,
        merchantId: this.$store.getters.userInfo.merchantId
      },
      rules: {
        pattern: [{ required: true, message: '请选择投放模式', trigger: 'change' }],
        showPosition: [
          {
            type: 'array',
            required: true,
            message: '请至少选择一个显示店铺',
            trigger: 'change'
          }
        ],
        showPicture: [{ required: true, message: '请选择投放图片', trigger: 'change' }]
      }
    }
  },
  activated() {
    let updateFlag = this.$route.query.updateFlag
    if (updateFlag) {
      this.$refs.table.refresh(updateFlag == 0 ? true : false)
    }
  },
  mounted() {
    this.getProvinceList()
    this.$store.commit('SET_MENU_HEAD_CONFIG', [{ name: 'ShopList', title: '门店管理' }])
  },
  methods: {
    // 获取城市集合
    getProvinceList() {
      this.getHttpServices()
        .getBaseService()
        .get('province/getProvinceCityCounty')
        .then(res => {
          let arr = res
          arr.forEach(item => {
            item.children.forEach(spanItem => {
              spanItem.children = null
            })
          })
          this.provinceList = arr
          this.getLogUtils().logWithTag('provinceList', this.provinceList)
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    filter(inputValue, path) {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1)
    },
    onCityChange(value, selectedOptions) {
      // this.getLogUtils().logWithTag(value, selectedOptions);
      if (value && value.length) {
        this.queryParams.provinceId = value[0]
        this.queryParams.cityId = value[1]
        this.defaultCityValue = [value[0], value[1]]
        this.getLogUtils().logWithTag('defaultCityValue', this.defaultCityValue)
      } else {
        this.defaultCityValue = []
        this.queryParams.provinceId = undefined
        this.queryParams.cityId = undefined
      }
    },
    handleCancel() {
      this.visible = false
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        return
      }
      if (info.file.status === 'done') {
        const url = this.getLatestUrlFromFileList(info.fileList)
        // Get this url from response in real world.
        this.ruleForm.showPicture = url
        this.getLogUtils().logWithTag('this.ruleForm.showPicture', this.ruleForm.showPicture)
      }
    },
    getLatestUrlFromFileList(fileList) {
      if (fileList && fileList.length > 0) {
        const lastIndex = fileList.length - 1
        if (fileList[lastIndex] && fileList[lastIndex].response) {
          return fileList[lastIndex].response.data
        }
      }
      return ''
    },
    //保存
    submitForm(ruleForm) {
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      this.submitFormData.showPosition = this.submitFormData.showPosition.join(',')
      this.submitLoading = true
      this.getHttpServices()
        .getUserService()
        .post('merchant/store/put-in/add', this.submitFormData)
        .then(res => {
          this.$message.success('投放设置保存成功')
          this.visible = false
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
        .finally(() => (this.submitLoading = false))
    },
    //打开弹窗
    openSetting() {
      this.visible = true
      this.getSettingInfo()
    },
    // 获取投放设置得回显
    getSettingInfo() {
      this.getHttpServices()
        .getUserService()
        .get('merchant/store/put-in/' + this.merchantId)
        .then(res => {
          if (res.pattern) {
            this.ruleForm = res
            if (res.showPosition) {
              this.ruleForm.showPosition = res.showPosition.split(',')
            } else {
              this.ruleForm.showPosition = []
            }
            if (res.status) {
              this.ruleForm.status = res.status
            } else {
              this.ruleForm.status = 2
            }
          }
        })
        .catch(reason => {
          this.getLogUtils().logWithTag('reason', reason)
        })
    },
    //去添加+修改门店
    onAddShop(shopId) {
      this.$router.push({
        name: 'AddShop',
        query: {
          shopId: shopId,
          serverUniqueId: this.$route.query.serverUniqueId
        }
      })
    },
    //去绑定账号
    onBindAccount(shopId) {
      this.$router.push({
        name: 'ShopBindAccount',
        query: {
          shopId: shopId,
          serverUniqueId: this.$route.query.serverUniqueId
        }
      })
    },
    //去店员业绩
    goPerformance(record) {

      this.$router.push({
        name: 'ClerkPerformance',
        query: {
          storeId: record.storeId,
          storeName: record.storeName,
          serverUniqueId: this.$route.query.serverUniqueId
        }
      })
    },
    deleteStore(id) {
      this.getHttpServices()
        .getUserService()
        .post('user/merchantStore/merchant/store/remove', {
          storeId: id
        })
        .then(res => {
          this.$message.success('删除成功')
          this.$refs.table.refresh(true)
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
    }
  }
}
</script>
<style lang="less" scoped>
.avatar-uploader > .ant-upload {
  width: 116px;
  height: 116px;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.avatar {
  width: 116px;
  height: 116px;
  display: block;
}

.ant-btn + .ant-btn {
  margin-left: 5px;
}
</style>